import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var DetailModal = function (_super) {
  __extends(DetailModal, _super);

  function DetailModal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DetailModal.prototype.isNeedPayeeInfo = function (formData) {
    return formData.isthird_party === String(this.$enum.common.BoolIntEnum.NO);
  };

  DetailModal.prototype.isNeedPayeeCaAddress = function (formData) {
    return this.isNeedPayeeInfo(formData) && formData.open_bank_country_code === this.$enum.mine.RegisterAreaCodeEnum.CA;
  };

  DetailModal = __decorate([Component], DetailModal);
  return DetailModal;
}(Vue);

export default DetailModal;